import { render, staticRenderFns } from "./PersonH5.vue?vue&type=template&id=d563b7e8&scoped=true"
import script from "./PersonH5.vue?vue&type=script&lang=js"
export * from "./PersonH5.vue?vue&type=script&lang=js"
import style0 from "./PersonH5.vue?vue&type=style&index=0&id=d563b7e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d563b7e8",
  null
  
)

export default component.exports